var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M748.3,432c85,38.3,147.2,116.1,147.2,216.7c0,143.7-110.1,250.2-262.2,250.2H2.5v-69.4h146v-759H2.5V1.1h630.9\n\tc149.6,0,239.4,97,239.4,233.4C872.8,325.5,822.5,396.1,748.3,432z M224,70.5v328h409.4c103,0,161.6-70.6,161.6-164\n\tc0-94.6-58.7-164-161.6-164H224z M224,468v361.5h409.4c107.7,0,184.4-79,184.4-180.8C817.7,547,737.5,468,633.4,468H224z\n\t M1343.3,829.5L1038,70.5H892V1.1h366.3v69.4h-138.9l288.5,718.3l287.3-718.3h-138.9V1.1h366.3v69.4h-146l-305.3,759H1627v69.4\n\th-439.3v-69.4H1343.3z M2345.3,898.9h-379.5v-69.4h146v-759h-146V1.1h379.5v69.4h-124.5L2781,760.1V70.5h-146V1.1h367.5v69.4h-146\n\tv759h146v69.4H2635v-69.4h110.1l-557.9-688.3v688.3h158L2345.3,898.9L2345.3,898.9z"}));
}

Logo.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 3005 900","style":{"enableBackground":"new 0 0 3005 900"},"xmlSpace":"preserve"};

module.exports = Logo;

Logo.default = Logo;
